import { ActivityImpl } from './activity.impl';
import { AuthImpl } from './auth.impl';
import { CoinPusherGameImpl } from './coinPusherGame.impl';
import { CraftingImpl } from './crafting.impl';
import { FlipCoinGameImpl } from './flipCoinGame.impl';
import { JackpotImpl } from './jackpot.impl';
import { MiscImpl } from './misc.impl';
import { NftImpl } from './nft.impl';
import { SeasonsImpl } from './seasons.impl';
import { StakeImpl } from './stake.impl';
import { StatisticsImpl } from './statistics.impl';
import { StreetMerchantImpl } from './streetMerchant.impl';
import { TokensImpl } from './tokens.impl';
import { UserImpl } from './user.impl';
import { type TRequestsHandler } from '~/utils/requestsProcessor/types';

export class APIImplementation {
  public readonly tokens: TokensImpl;
  public readonly user: UserImpl;
  public readonly crafting: CraftingImpl;
  public readonly statistics: StatisticsImpl;
  public readonly flipCoinGame: FlipCoinGameImpl;
  public readonly coinPusherGame: CoinPusherGameImpl;
  public readonly auth: AuthImpl;
  public readonly activity: ActivityImpl;
  public readonly nft: NftImpl;
  public readonly seasons: SeasonsImpl;
  public readonly streetMerchant: StreetMerchantImpl;
  public readonly jackpot: JackpotImpl;
  public readonly stakeImpl: StakeImpl;
  public readonly misc: MiscImpl;

  constructor(private readonly makeRequest: TRequestsHandler) {
    this.tokens = new TokensImpl(this.makeRequest);
    this.user = new UserImpl(this.makeRequest);
    this.crafting = new CraftingImpl(this.makeRequest);
    this.statistics = new StatisticsImpl(this.makeRequest);
    this.flipCoinGame = new FlipCoinGameImpl(this.makeRequest);
    this.coinPusherGame = new CoinPusherGameImpl(this.makeRequest);
    this.auth = new AuthImpl(this.makeRequest);
    this.activity = new ActivityImpl(this.makeRequest);
    this.nft = new NftImpl(this.makeRequest);
    this.seasons = new SeasonsImpl(this.makeRequest);
    this.streetMerchant = new StreetMerchantImpl(this.makeRequest);
    this.jackpot = new JackpotImpl(this.makeRequest);
    this.stakeImpl = new StakeImpl(this.makeRequest);
    this.misc = new MiscImpl(this.makeRequest);
  }
}
